import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'st-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  @Input() title: string;
  @Input() cancelButtonText: string;
  @Input() confirmButtonText: string;
  @Input() open: boolean;
  @Input() dismissible = true;

  @Output() dismiss: EventEmitter<Event> = new EventEmitter();
  @Output() confirm: EventEmitter<Event> = new EventEmitter();
  @Output() cancel: EventEmitter<Event> = new EventEmitter();

  onDismiss(event: Event) {
    if (this.dismissible) {
      this.dismiss.emit(event);
    }
  }

  onConfirm(event: Event) {
    this.confirm.emit(event);
  }

  onCancel(event: Event) {
    this.cancel.emit(event);
  }
}
